import { createAction, props } from '@ngrx/store'
import { InvoiceEntity } from './invoice.models'
import { GbAppPayment } from 'libs/gb-front/payment/util/src/lib/gb-payment.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadInvoice = createAction('[Invoice Page] Load Invoice')

export const loadInvoiceVolunteer = createAction('[Invoice Page] Load Invoice Volunteer')

export const loadInvoiceSuccess = createAction(
  '[Invoice/API] Load Invoice Success',
  props<{ invoice: InvoiceEntity }>(),
)

export const loadInvoiceFailure = createAction(
  '[Invoice/API] Load Invoice Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const downloadInvoicePdf = createAction('[Invoice/API] Download Invoice PDF')
export const downloadInvoicePdfSuccess = createAction(
  '[Invoice/API] Download Invoice Success',
  props<{ invoice: Blob }>(),
)

export const sendInvoiceEmail = createAction('[Invoice/API] Send Invoice Email', props<{ email: string }>())

export const checkout = createAction('[Invoice/API] Checkout invoice')

export const checkoutSuccess = createAction(
  '[Invoice/API] Checkout invoice Success',
  props<{ payment: GbAppPayment | null }>(),
)

export const confirmPayment = createAction('[Invoice/API] Confirm payment', props<{ payment: GbAppPayment | null }>())

export const checkoutFailure = createAction(
  '[Invoice/API] Checkout invoice Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearInvoice = createAction('[Invoice/Page] Clear invoice')

export const paymentSuccess = createAction('[Invoice/page] Payment success')

export const openPaymentDialog = createAction('[Invoice/page] Open payment dialog')

export const prepareInvoice = createAction('[Invoice/page] prepare invoice to be paid')

export const resyncInvoice = createAction('[Invoice/Page] Resync Invoice')
